// extracted by mini-css-extract-plugin
export default {"mobileAmenity":"_3pXI-lwCoEB8eOQL1LNLEK"};